
import React, { Component } from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux';
import _ from 'lodash';
import { format } from 'date-fns'

import { DateTitle } from './components'
import { DayView, WeekView, MonthView } from './views'
import { ItemModal } from 'features'

import * as actionCreators from 'store/actions'
import { moduleContext, itemContext, userContext, accessContext } from 'context'
import moment from 'moment-timezone';
import { timezoneDate, momentDate } from 'utils'
import { Alert } from 'schema'

const Container = styled.div`
    border-radius: 5px;
    width: 100%;
    height: 100%;
    /* max-height: calc(100vh - 2.5rem); */
    padding: ${props => props.styles.padding};
    overflow-y: auto;
    overflow-x: visible;
    position: relative;
`

class CalendarModule extends Component {
    constructor(props){
        super(props);
        this.virtuoso = React.createRef();
        this.ref = React.createRef();
        const timezone = this.props.user ? this.props.user['timezone'] : moment.tz.guess();
        const date = this.props.accessProps && this.props.accessProps['date']
        this.state = {
            date: date || this.props.date || moment().tz(timezone).set({hour: 0, minute: 0, second: 0}),
            range: this.props.accessProps && this.props.accessProps['range'] || 'day',
            direction: null,
            showNotes: true,
            showTasks: true,
            filters: {
                priorities: Object.values(itemContext.PRIORITY),
                pageIDs: Object.keys(this.props.data['pages'])
            },
            settings: {
                work_week: true,
                show_completed: true,
                step_size: 10,
                start_hour: 6
            }
        }

        this.toggleStyle = {
            backgroundColor: 'transparent',
            padding: '0.3rem', 
            fontSize: '1rem'
        }

        // console.log('[CalendarModule]', this.props.loadedDates)
    }

    componentDidMount(){
        if(!this.props.modal & this.props.showAccess){
            this.props.setAccess(false, this.props.access, this.props.accessProps)
        }
    }

    static getDerivedStateFromProps(props, state) {
        const timezone = props.user ? props.user['timezone'] : moment.tz.guess();
        state['date'] = props.accessProps['date'] && props.accessProps['date'] || moment().tz(timezone).set({hour: 0, minute: 0, second: 0})
        return state
    }

    collectRefs = (refs) => {
        // console.log(refs)
        const y = refs[parseInt(this.props.user['calendar_initial_time'])-1] && refs[parseInt(this.props.user['calendar_initial_time'])-1].current.getBoundingClientRect()['y']
        const yOffset = this.ref && this.ref.current.getBoundingClientRect()['y'] + 10
        // console.log({y, yOffset, final: y - yOffset})
        this.ref && y && this.ref.current.scrollTo(0, y - yOffset)
    }

    selectDate = date => {
        let direction
        // console.log({ date: date.format('YYYY-MM-DD'), loaded: this.props.loadedDates, range: this.state.range })
        this.setState({date: date, direction: direction})
        this.props.setAccess(this.props.showAccess, accessContext.CALENDAR['value'], {range: this.state.range, date: date})

        // Load data if needed
        this.loadDates(date, this.state.range)
    }

    loadDates = (value, range) => {
        const dateRange = this.getDateRange(value, range)
        const datesToLoad = _.difference(dateRange, this.props.loadedDates)
        datesToLoad.length > 0 && this.props.loadDates(datesToLoad, this.props.data, this.props.uid)
    }

    getDateRange = (value, range) => {
        switch(range){
            case 'day':
                return [value.format('YYYY-MM-DD')]
            case 'week':
                return _.range(0,5).map(i => value.startOf('week').add(i,'days').format('YYYY-MM-DD'))
            case 'month':
                return _.range(0,value.endOf('month').date()).map(i => value.startOf('month').add(i,'days').format('YYYY-MM-DD'))
        }
    }

    selectRange = range => {
        this.setState({range: range})
        this.props.setAccess(this.props.showAccess, 'CALENDAR', {range: range})

        // Load data if needed
        this.loadDates(this.state.date, range)
    }

    onSchedule = (data) => { // Not used anymore after shifting to dnd-kit, logic is at ListView/KanbanView onDrop
        // console.log('[UpcomingModule] onSchedule', data)
        const {id, item, schedule} = data
        let updatedItem = item
        if(item['itemID']){
            // Update item
            for (const [key, value] of Object.entries(schedule)) {
                updatedItem[key] = value
            }

            let updatedAlerts = []

            // Update existing alerts
            if(updatedItem['alerts'].length > 0){
                console.log({item: updatedItem['alerts'], alerts: this.props.data['alerts']})
                Object.values(updatedItem['alerts']).map(alertID => {
                    let updatedAlert = this.props.data['alerts'][alertID]
                    let option = {}
                    option[updatedAlert['reference']['metric']] = updatedAlert['reference']['value']
                    const refDate = schedule['start_time'] || schedule['start_date']
                    const subtitle = refDate.format(schedule['start_time'] ? 'ddd, MMM D Y (h:mma)' : 'ddd, MMM D Y')
                    // const subtitle = schedule['start_date'].format('ddd, MMM D Y')
                    updatedAlert['date'] = schedule['start_time'] || schedule['start_date'] || schedule['end_time'] || schedule['end_date']
                    updatedAlert['subtitle'] = subtitle
                    updatedAlert['date'] = updatedAlert['date'].toISOString()
                    updatedAlerts.push(updatedAlert)
                    // console.log(updatedAlert['date'].toDate())
                })
            } 
            
            // Create new alerts
            else {
                const title = item.getPlainText()
                const refDate = schedule['start_time'] || schedule['start_date']
                const subtitle = refDate.format(schedule['start_time'] ? 'ddd, MMM D Y (h:mma)' : 'ddd, MMM D Y')

                const newAlert = new Alert({
                    userID: this.props.uid,
                    title: title,
                    subtitle: subtitle,
                    date: schedule['start_time'] || schedule['start_date'] || schedule['end_time'] || schedule['end_date'],
                    secID: {id: item['itemID'], relation: 'item'}
                })
                updatedAlerts.push(newAlert)
            }
            this.props.updateItemSchedule(updatedAlerts, updatedItem, this.props.data, this.props.uid, this.props.sessionId)
        }
    }

    onDrillDown = (date) => {
        console.log('[UpcomingModule] onDrilldown', date)
        this.setState({
            date: timezoneDate(date, this.props.user['timezone']),
            range: 'day',
        })
    }

    onFilter = (type, value) => {
        const current = {...this.state.filters}
        const updated = {...this.state.filters}
        if(type === 'PRIORITY') {
            if(current['priorities'].includes(value)){
                updated['priorities'].splice(updated['priorities'].indexOf(value), 1)
            } else {
                updated['priorities'].push(value)
            }
        } else if(type === 'PAGES') {
            if(current['pageIDs'].includes(value)){
                updated['pageIDs'].splice(updated['pageIDs'].indexOf(value), 1)
            } else {
                updated['pageIDs'].push(value)
            }
        }
        console.log(updated)
        this.setState({filters: updated})
    }

    getStyles = () => {
        const width = window.innerWidth || this.props.body.clientWidth
        const defaultStyle = {
            primaryColor: 'var(--primary-color)',
            secondaryColor: 'var(--secondary-color)',
            secondaryColor2: 'var(--primary-accent2-color)',                  
            padding: '0 0.5rem',
            // padding: ['week', 'month'].includes(this.state.range) & width < 1024 ? '0rem 0 0 0'
            //         : ['day'].includes(this.state.range) & width < 1024 ? '0rem var(--main-padding-width-smaller)'
            //         : this.props.modal & this.props.user['full_width'] ? '0.5rem var(--main-padding-width-small)' 
            //         : this.props.modal ? '0rem var(--main-padding-width)'
            //         : ['day'].includes(this.state.range) ? '0.5rem 0 0 0.5rem'
            //         : '0.5rem 0 0 0.5rem'
        }
        const updatedStyle = Object.assign({}, defaultStyle, this.props.styles)
        return updatedStyle
    }

    getEvents = () => {
        const timezone = this.props.user['timezone']
        let events = []
        let itemIDs = []

        this.props.user['subscription_plan'] !== userContext.PLANS.PERSONAL && Object.values(this.props.data['items']).map(item => {
            const status = item['status'] === itemContext.STATUS.INCOMPLETE || this.props.user['calendar_show_completed']
            const priority = this.state.filters['priorities'].includes(item['priority'])
            const pageID = this.state.filters['pageIDs'].includes(item['pageID'])
            const start = item['start_time'] ? momentDate(item['start_time'], timezone) 
                        : item['start_date'] ? momentDate(item['start_date'], timezone)
                        : null
            const end = item['end_time'] ? momentDate(item['end_time'], timezone) 
                        : item['end_date'] ? momentDate(item['end_date'], timezone)
                        : null
            if(status & priority & pageID && (start | end)){
                if(!itemIDs.includes(item['itemID'])){
                    events.push({
                        start: start,
                        end: end,
                        allDay: start === end,
                        title: item.getPlainText(),
                        item: item
                    })
                    
                    itemIDs.push(item['itemID'])
                }
                
            }
        })
        return events
    }

    onSelectEvent = (data) => {
        console.log('[CalendarModule]', data)
        const item = data['item']
        item && this.props.setModal(<ItemModal itemID={item['itemID']}/>, `${item['itemID']}_ItemModal`)
        this.props.setInput(null,null)
    }

    render() {
        const width = window.innerWidth || this.props.body.clientWidth
        const updatedStyle = this.getStyles()
        const modal = this.props.modal || width < 1024
        const events = this.getEvents()
        return(
            <Container styles={updatedStyle} ref={this.ref}>
                <DateTitle events={events} styles={updatedStyle} forward={this.state.range === 'day'}
                    date={this.state.date} type={this.state.range} filters={this.state.filters} 
                    onSelect={this.selectDate} onRange={this.selectRange} onFilter={width < 1024 | modal | this.state.range === 'day' && this.onFilter}/>
                {this.state.range === 'day' ? <DayView key={`${this.state.date.format('D-M-Y')}_day`} events={events} modal={modal} date={this.state.date} styles={this.props.styles} onSchedule={this.onSchedule} onDrillDown={this.onDrillDown} onFilter={this.onFilter} onSelectEvent={this.onSelectEvent} collectRefs={this.collectRefs}/>
                : this.state.range === 'week' ? <WeekView key={`${this.state.date.format('D-M-Y')}_week`} events={events} modal={modal} date={this.state.date} styles={this.props.styles} onSchedule={this.onSchedule} onDrillDown={this.onDrillDown} onSelectDate={this.selectDate} onFilter={this.onFilter} onSelectEvent={this.onSelectEvent}/>
                : this.state.range === 'month' ? <MonthView key={`${this.state.date.format('D-M-Y')}_month`} events={events} modal={modal} date={this.state.date} styles={this.props.styles} onSchedule={this.onSchedule} onDrillDown={this.onDrillDown} onSelectDate={this.selectDate} onFilter={this.onFilter} onSelectEvent={this.onSelectEvent}/>
                : <div>Something went wrong</div>}
            </Container>            
        )
    }
}

const mapStateToProps = state => {
    return {
        uid: state.auth.uid,
        user: state.auth.user,
        data: state.db.present.data && state.db.present.data.toJS(),
        activePageID: state.auth.activePageID,
        sessionId: state.content.sessionId,
        loadedDates: state.db.present.loadedDates,

        window: state.content.window,
        body: state.content.body,

        showAccess: state.content.showAccess,
        access: state.content.access,
        accessProps: state.content.accessProps,
    }
};

const mapDispatchToProps = dispatch => {
    return {
        setInput: (inputID) => dispatch(actionCreators.setInput(inputID)),
        setModal: (element, id) => dispatch(actionCreators.setModal(element, id)),
        setAccess: (showAccess, module, accessProps) => dispatch(actionCreators.setAccess(showAccess, module, accessProps)),
        updateItemSchedule: (alerts, item, data, uid, sessionId) => dispatch(actionCreators.updateItemSchedule(alerts, item, data, uid, sessionId)),
        loadDates: (dates, data, uid) => dispatch(actionCreators.loadDates(dates, data, uid))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(CalendarModule);